"use client";

import type { ReactNode } from "react";
import { AttributionCapture } from "./AttributionCapture";
import { ConsentProvider } from "./ConsentProvider";
import { GoogleTagManager } from "./GoogleTagManager";

export function AnalyticsRoot({
  children,
  locale,
}: {
  children: ReactNode;
  locale: string;
}) {
  return (
    <ConsentProvider locale={locale}>
      <GoogleTagManager />
      <AttributionCapture />
      {children}
    </ConsentProvider>
  );
}
